import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function formatINR(amount) {
  return "₹" + Number(amount || 0).toLocaleString("en-IN");
}

export function discountPct(price, mrp) {
  if (!mrp || mrp <= price) return 0;
  return Math.round(((mrp - price) / mrp) * 100);
}

const META_EVENTS = {
  view_item: (p) => ["ViewContent", { content_ids: [p.item_id], content_type: "product", value: p.price, currency: p.currency }],
  add_to_cart: (p) => ["AddToCart", { content_ids: (p.items || []).map((i) => i.item_id), content_type: "product",
    value: (p.items || []).reduce((s, i) => s + (i.price || 0) * (i.quantity || 1), 0), currency: "INR" }],
  begin_checkout: (p) => ["InitiateCheckout", { value: p.value, currency: p.currency }],
  add_shipping_info: (p) => ["AddPaymentInfo", { value: p.value, currency: p.currency }],
  purchase: (p) => ["Purchase", { value: p.value, currency: p.currency, content_ids: p.content_ids, content_type: "product", num_items: p.num_items }],
};

export async function track(name, props = {}) {
  try {
    if (!["all", '"all"'].includes(localStorage.getItem("hh_consent"))) return; // legacy raw + JSON values
    api.post("/track", { name, props });
    if (window.dataLayer) window.dataLayer.push({ event: name, ...props });
    if (window.fbq && META_EVENTS[name]) window.fbq("track", ...META_EVENTS[name](props));
  } catch (e) { /* analytics must never block shopping */ }
}
